$(".trustpilot_review_right").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: true,
  autoplay: true,
  pauseOnHover:false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      },
    },
  ],
});

$(document).ready(function() {
            // Function to reorder divs on mobile
            function reorderDivs() {
                if ($(window).width() <= 767) {
                    // If the screen width is less than or equal to 767px (mobile)
                    // Move div2 after div1
                    $(".review_details").insertAfter(".atc-buuton");
                } else {
                    // If the screen width is greater than 767px (not mobile)
                    // Move div2 before div1 (back to the original order)
                    //$(".review_details").insertBefore(".atc-buuton");
                }
            }

            // Initial call to reorder divs
            reorderDivs();

            // Listen for window resize events
            $(window).resize(function() {
                // Reorder divs whenever the window is resized
                reorderDivs();
            });
        });


document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab-btn');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const wrapper = this.closest('.custom-tabs');

      wrapper.querySelectorAll('.tab-btn').forEach(btn => {
        btn.classList.remove('active');
      });

      wrapper.querySelectorAll('.tab-content').forEach(content => {
        content.classList.remove('active');
      });

      this.classList.add('active');

      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
      }
    });
  });
});        